/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from "chart.js";
import { useParams } from "react-router-dom";
import { SyncLoader } from "react-spinners";
import * as S from "./styles";
import axios from "axios";
import { API_URL } from "../../config";
import { NoAnswers } from "./styles";

interface StatisticsFormProps {
  id: string;
  title: string;
  cards?: StatisticsCardProps[];
}

interface StatisticsCardProps {
  id: string;
  title: string;
  required: boolean;
  answerCount: number;
  noAnswerCount: number;
  snippet: StatisticsSnippetProps[];
}

interface StatisticsSnippetProps {
  answer: string;
  count: number;
}

ChartJS.register(ArcElement, Tooltip, Legend);

const Statistics = () => {
  const { programId } = useParams();
  const [statisticsCards, setStatisticsCards] = useState<StatisticsCardProps[]>([]);
  const [title, setTitle] = useState<string>("");
  const [accessKey, setAccessKey] = useState<string>("");
  const [hasPermission, setHasPermission] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // localStorage에 에 있으면 꺼내 쓰기
    if (localStorage.getItem("accessKey") !== null) {
      setAccessKey(localStorage.getItem("accessKey")!);
    }

    // 메시지 수신
    const handleMessage = (event: MessageEvent) => {
      // 보낸 페이지의 origin 확인
      const { accessKey } = event.data;
      if (accessKey !== null && accessKey !== undefined) {
        setAccessKey(accessKey);
        localStorage.setItem("accessKey", accessKey);
      }
    };
    window.addEventListener("message", handleMessage);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const getStatisticsFormProps = async () => {
    console.log("fetch answer data from the server");
    const response = await axios.get(`${API_URL}/forms/${programId}/statistics`, {
      headers: {
        Authorization: `Bearer ${accessKey}`,
      },
    });
    const form = response.data.result as StatisticsFormProps;

    const newStatisticsCards: StatisticsCardProps[] = [];

    form.cards?.forEach((card) => {
      const newSnippets: StatisticsSnippetProps[] = [];
      card.snippet.forEach((snippet) => {
        newSnippets.push({
          answer: snippet.answer,
          count: snippet.count,
        });
      });
      newStatisticsCards.push({
        id: `card-${card.id}`,
        title: card.title,
        required: card.required,
        answerCount: card.answerCount,
        noAnswerCount: card.noAnswerCount,
        snippet: newSnippets,
      });
    });

    return {
      id: form.id,
      title: form.title,
      cards: newStatisticsCards,
    } as StatisticsFormProps;
  };

  const generateChartOptions = (): ChartOptions<"pie"> => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "left",
        align: "start",
        labels: {
          boxWidth: 20,
          boxHeight: 20,
        },
      },
    },
    elements: {
      arc: {
        borderWidth: 1,
        hoverOffset: 5,
      },
    },
    layout: {
      padding: {},
    },
  });

  const getSum = (snippets: StatisticsSnippetProps[]) => {
    let sum = 0;
    snippets.forEach((snippet) => {
      sum += snippet.count;
    });
    return sum;
  };

  const calculatePercentage = (count: number, sum: number) => Math.round((count * 100) / sum);

  const generateChartData = (snippets: StatisticsSnippetProps[]) => ({
    labels: snippets.map(
      (snippet) =>
        `${snippet.answer} ${calculatePercentage(snippet.count, getSum(snippets))}% (${
          snippet.count
        })`,
    ),
    datasets: [
      {
        data: snippets.map((snippet) => snippet.count),
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
          "#FF9F40",
          "#66ff66",
        ],
      },
    ],
  });

  useEffect(() => {
    // Fetch data from the server
    if (accessKey !== "" && accessKey !== null && accessKey !== undefined) {
      getStatisticsFormProps()
        .then((res) => {
          setStatisticsCards(res.cards ?? []);
          setTitle(res.title);
          setHasPermission(true);
          setIsLoading(false);
        })
        .catch((err) => {
          setHasPermission(false);
        });
    }
  }, [accessKey]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <S.Container>
      <S.SectionTitle>{title}</S.SectionTitle>
      {!hasPermission && !isLoading ? (
        <S.NeedLogin>
          ⚠️ 로그인 정보가 일치하지 않습니다. 어드민 페이지에서 다시 접근해주세요.
          <br />
        </S.NeedLogin>
      ) : null}

      {isLoading ? (
        <S.NeedLogin>
          <SyncLoader /> 로딩중입니다...
        </S.NeedLogin>
      ) : (
        <>
          <S.NoticeTitle>* 필수항목</S.NoticeTitle>
          {statisticsCards.length > 0 ? (
            <S.Section>
              {statisticsCards.map((card) => (
                <S.ResultContainer>
                  <S.TitleSection>
                    <S.Title>
                      {card.title} (답변 {card.answerCount}건 / 무응답 {card.noAnswerCount}건)
                    </S.Title>
                    {card.required ? <S.RequireMark>*</S.RequireMark> : null}
                  </S.TitleSection>
                  <div style={{ marginTop: "0px", height: "300px" }}>
                    <Pie data={generateChartData(card.snippet)} options={generateChartOptions()} />
                  </div>
                </S.ResultContainer>
              ))}
            </S.Section>
          ) : (
            <S.NoAnswers>* 아직 답변이 없거나 통계를 표시할 문항이 없습니다.</S.NoAnswers>
          )}
        </>
      )}
    </S.Container>
  );
};

export default Statistics;
